import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card, InputGroup, ListGroup } from 'react-bootstrap';
import Search from "../assets/images/search-icon.svg";
import Location from "../assets/images/location-icon.svg"
import Currency from "../assets/images/currency.svg";
import Star from "../assets/images/pre-qualified/star.svg";
import One from "../assets/images/pre-qualified/1.svg";
import Two from "../assets/images/pre-qualified/2.svg";
import Three from "../assets/images/pre-qualified/3.svg";
import Four from "../assets/images/pre-qualified/4.svg";
import Five from "../assets/images/pre-qualified/5.svg";
import ArrowIcon from "../assets/images/pre-qualified/top-right-arrow.svg";
import useCounties from "../hooks/useCounties";
import useSuburbs from "../hooks/useSuburbs";
import useCategories from '../hooks/useCategories';
import Select from "react-select";


import { useNavigate } from 'react-router-dom';
import { MATCH_TO_PROVIDERS, GET_COUNTY_CITIES, GET_CITY_SUBURBS } from '../api/constants';

// Sample agent data


function GetPreQualifiedComp() {
    const { suburbs } = useSuburbs();
    const { counties } = useCounties();
    const { categories } = useCategories();
    const [providers, setProviders] = useState([])
    const [error, setError] = useState([])

    const [suburb, setSuburb] = useState([])
    const [cities, setCities] = useState([])
    const [city_suburbs, setCitySuburbs] = useState([])

    const [showThankYou, setShowThankYou] = useState(false);
    const handleSeeMore = (agentId) => {
        setSelectedAgent(agentId);
        setShowThankYou(true);
    };

    const inputGroupRef = useRef(null);
    const [inputHeight, setInputHeight] = useState(0);
    const [filtered, setFiltered] = useState([]);

    useEffect(() => {
        if (inputGroupRef.current) {
            const height = inputGroupRef.current.offsetHeight;
            setInputHeight(height);
        }
    }, []);
    useEffect(() => {
        const handleResize = () => {
            if (inputGroupRef.current) {
                setInputHeight(inputGroupRef.current.offsetHeight);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const handleChange = (e) => {
        const value = e.target.value;
        setSuburb(value);

        if (value.length > 0) {
            const results = suburbs.filter((item) =>
                item.toLowerCase().includes(value.toLowerCase())
            );
            setFiltered(results);
        } else {
            setFiltered([]);
        }
    };

    const handleSelect = (item) => {
        setSuburb(item);
        setFiltered([]);
    };
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedAgent, setSelectedAgent] = useState(null);
    const [formData, setFormData] = useState({
        // Step 1
        buyingJourney: '',
        lookingToBuy: '',
        newHomeUse: '',
        category_id: '',
        planningToSpend: '',
        planningToPayMonthly: '',
        downPaymentClosing: '',

        // Step 2
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        street_address: '',
        county: '',
        city: '',
        my_current_location: '',//suburb_id ->prequalified_logs
        monthlyIncome: '',
        date_of_birth: '',
        credit_score: '',
        hasRealtor: '',
        buyingWithOthers: '',
        bankruptcy: '',
        foreclosure: '',

        // Step 3
    });

    const handleInputChange = (e) => {
        const { name, value, type } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value === '' ? ''
                : type === 'number' || ['category_id', 'city', 'county', 'newHomeUse', 'my_current_location'].includes(name)
                    ? value
                    : value
        }));
    };


    const handleNext = () => {
        if (suburb == "") {
            setError("Enter Home Location")
        } else if (formData.category_id == "") {
            setError("Select Home Type")
        } else if (formData.planningToSpend == "") {
            setError("Please indicate how much your planning to spend on new home")
        } else if (formData.planningToPayMonthly == "") {
            setError("Please indicate how much your planning to pay for mortgage per month")
        } else if (formData.downPaymentClosing == "") {
            setError("Please indicate how much your planning to spend upfront to cover your down payment and closing costs")
        } else {
            setError("")
            if (currentStep < 3) {
                setCurrentStep(prev => prev + 1);
            }
        }


    };

    const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep(prev => prev - 1);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const home_location = suburb.split(",")[0].trim();
            if (formData.first_name == "" || formData.last_name == "" || formData.phone_number  =="" || formData.email =="" || formData.date_of_birth == "") {
                setError("Please enter your personal details");
            }else if (formData.monthlyIncome == "" || formData.credit_score == ""){
                setError("Please enter your monthly income and credit score");
            }else if (formData.street_address == "" || formData.county == "" || formData.city  =="" || formData.my_current_location == ""){
                setError("Please enter your current location details");
            }else if (formData.hasRealtor == "" || formData.buyingWithOthers == "" || formData.bankruptcy  =="" || formData.foreclosure ==""){
                setError("Please fill out the remaining items");
            } else {
                const res = await fetch(MATCH_TO_PROVIDERS, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        // ...(token && { Authorization: `Bearer ${token}` }),
                    },

                    body: JSON.stringify({
                        ...formData,
                        home_location

                    }),
                });

                const data = await res.json();
                setProviders(data.data)
                handleNext()
                if (!res.ok) {
                    throw new Error(data.message || "Failed to to send request");
                }
            }



        } catch (err) {
            console.error("Viewing request error:", err.message);
        }
    };

    const renderStepIndicator = () => (
        <div className="step-indicator text-center">
            <span className="step-text">Step {currentStep} of 3</span>
        </div>
    );

    const fetchCities = async (countyId) => {
        try {
            const response = await fetch(`${GET_COUNTY_CITIES}/${countyId}`);
            const data = await response.json();

            // ✅ tolerate different API shapes
            if (Array.isArray(data?.data.cities)) {
                setCities(data.data.cities);
            } else if (Array.isArray(data)) {
                setCities(data);
            } else {
                setCities([]);
            }
        } catch (err) {
            console.error("Error fetching cities:");
        }
    };

    const fetchSuburbs = async (cityId) => {
        try {
            const response = await fetch(`${GET_CITY_SUBURBS}/${cityId}`);
            const data = await response.json();

            // ✅ tolerate different API shapes
            if (Array.isArray(data?.data)) {
                setCitySuburbs(data.data);
            } else if (Array.isArray(data)) {
                setCitySuburbs(data);
            } else {
                setCitySuburbs([]);
            }
        } catch (err) {
            console.error("Error fetching cities:");
        }
    };



    const renderStep1 = () => (
        <div className="step-content">
            <Row className="g-4">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Where are you in your home-buying journey? <span>*</span></Form.Label>
                        <Form.Select
                            name="buyingJourney"
                            value={formData.buyingJourney}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">I'm thinking about buying</option>
                            <option value="researching">Just researching</option>
                            <option value="ready">Ready to buy</option>
                            <option value="urgent">Need to buy soon</option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group>
                        <Form.Label>When are you looking to buy? <span>*</span></Form.Label>
                        <Form.Select
                            name="lookingToBuy"
                            value={formData.lookingToBuy}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">4-6 months</option>
                            <option value="0-3">0-3 months</option>
                            <option value="6-12">6-12 months</option>
                            <option value="12+">12+ months</option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col xs={12}>
                    <Form.Group>
                        <Form.Label>In which suburb are you looking to buy? <span>*</span></Form.Label>
                        <InputGroup ref={inputGroupRef}>
                            <Form.Control
                                type="search"
                                placeholder="Enter a suburb"
                                value={suburb}
                                onChange={handleChange}
                                required
                            />
                            <img src={Search} alt="" />

                        </InputGroup>
                        {filtered.length > 0 && (
                            <ListGroup style={{ top: inputHeight + 4, }}>
                                {filtered.map((item, index) => (
                                    <ListGroup.Item
                                        key={index}
                                        action
                                        onClick={() => handleSelect(item)}
                                    >
                                        <img src={Location} alt="" /> {item}
                                    </ListGroup.Item>
                                ))}
                            </ListGroup>
                        )}
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group>
                        <Form.Label>How will you use your new home? <span>*</span></Form.Label>
                        <Form.Select
                            name="newHomeUse"
                            value={formData.newHomeUse}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="primary">Primary residence</option>
                            <option value="secondary">Secondary home</option>
                            <option value="investment">Investment property</option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group>
                        <Form.Label>What kind of home are you looking for? <span>*</span></Form.Label>
                        <Form.Select
                            name="category_id"
                            value={formData.category_id}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Select Home Type</option>
                            {categories.map((category) => (
                                <option key={category.id} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col xs={12}>
                    <Form.Group>
                        <Form.Label>How much are you planning to spend on your new home? <span>*</span></Form.Label>
                        <div className="input-with-icon">
                            <span className="currency-icon"><img src={Currency} alt="" /></span>
                            <Form.Control
                                type="number"
                                name="planningToSpend"
                                placeholder="0"
                                value={formData.planningToSpend}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <Form.Text className="text-muted">
                            If you're not sure, feel free to estimate.
                        </Form.Text>
                    </Form.Group>
                </Col>

                <Col xs={12}>
                    <Form.Group>
                        <Form.Label>How much are you willing to pay per month for a mortgage? <span>*</span></Form.Label>
                        <div className="input-with-icon pr-54">
                            <span className="currency-icon"><img src={Currency} alt="" /></span>
                            <Form.Control
                                type="number"
                                name="planningToPayMonthly"
                                placeholder="0"
                                value={formData.planningToPayMonthly}
                                onChange={handleInputChange}
                                required
                            />
                            <span className="month">/ Month</span>
                        </div>
                    </Form.Group>
                </Col>

                <Col xs={12}>
                    <Form.Group>
                        <Form.Label>How much are you willing to spend upfront to cover your down payment and closing costs? <span>*</span></Form.Label>
                        <div className="input-with-icon">
                            <span className="currency-icon"><img src={Currency} alt="" /></span>
                            <Form.Control
                                type="text"
                                name="downPaymentClosing"
                                placeholder="0"
                                value={formData.downPaymentClosing}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                    </Form.Group>
                </Col>
            </Row>
            <div className="d-flex justify-content-center mt-4 mt-lg-5 ">
                <Button className="custom-bttn style-3 w-300 px-5" onClick={handleNext}>
                    Next
                </Button>
            </div>

        </div>
    );

    const renderStep2 = () => (
        <div className="step-content">
            {/* Form Fields */}
            <h3 className="section-title mb-3">Just a few more details</h3>
            <p className="section-subtitle">
                We'll use this information to fill out the paperwork for you, so you don't have to.<br />
                We will never sell your information to third party lenders without your consent.
            </p>

            <Row className="g-3">
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>First name <span>*</span></Form.Label>
                        <Form.Control
                            type="text"
                            name="first_name"
                            placeholder="Enter name"
                            value={formData.first_name}
                            onChange={handleInputChange}
                            required
                        />
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Last name <span>*</span></Form.Label>
                        <Form.Control
                            type="text"
                            name="last_name"
                            placeholder="Enter name"
                            value={formData.last_name}
                            onChange={handleInputChange}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Phone number <span>*</span></Form.Label>
                        <Form.Control
                            type="tel"
                            name="phone_number"
                            placeholder="Enter phone number"
                            value={formData.phone_number}
                            onChange={handleInputChange}
                            required
                        />
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Email address <span>*</span></Form.Label>
                        <Form.Control
                            type="email"
                            name="email"
                            placeholder="Enter email address"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Date of Birth <span>*</span></Form.Label>
                        <Form.Control
                            type="date"
                            name="date_of_birth"
                            placeholder="Select DOB"
                            value={formData.date_of_birth}
                            onChange={handleInputChange}
                            required
                        />
                    </Form.Group>
                </Col>
                <Col xs={12}>
                    <h5 className='form-title'>Your Income and Credit Score</h5>
                </Col>
                <Row>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Monthly Income <span>*</span></Form.Label>
                            <Form.Control
                                type="number"
                                name="monthlyIncome"
                                placeholder="Enter your monthly income"
                                value={formData.monthlyIncome}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Credit Score <span>*</span></Form.Label>
                            <Form.Control
                                type="number"
                                name="credit_score"
                                placeholder="Enter your credit score"
                                value={formData.credit_score}
                                onChange={handleInputChange}
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Col xs={12}>
                    <h5 className='form-title'>Your current address</h5>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Street address <span>*</span></Form.Label>
                        <Form.Control
                            name='street_address'
                            type="text"
                            placeholder="Enter your street address"
                            value={formData.street_address}
                            onChange={handleInputChange}
                        />


                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group>
                        <Form.Label>County <span>*</span></Form.Label>
                        <Form.Select
                            name="county"
                            value={formData.county}
                            onChange={(e) => {
                                handleInputChange(e);
                                fetchCities(e.target.value);
                            }}

                            required
                        >
                            <option value="">Select County</option>

                            {counties.map((county) => (
                                <option key={county.id} value={county.id}>
                                    {county.county_name}
                                </option>
                            ))}
                        </Form.Select>

                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>City <span>*</span></Form.Label>
                        <Form.Select
                            name="city"
                            value={formData.city}
                            onChange={(e) => {
                                handleInputChange(e);
                                fetchSuburbs(e.target.value);
                            }}
                            required
                        >
                            <option value="">Select City</option>

                            {cities?.map((city) => (
                                <option key={city.id} value={city.id}>
                                    {city.city_name}
                                </option>
                            ))}


                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group>
                        <Form.Label>Suburb <span>*</span></Form.Label>
                        <Form.Select
                            name="my_current_location"
                            value={formData.my_current_location}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Select Suburb</option>

                            {city_suburbs?.map((suburb) => (
                                <option key={suburb.id} value={suburb.id}>
                                    {suburb.suburb_name}
                                </option>
                            ))}


                        </Form.Select>
                    </Form.Group>
                </Col>



                {/* Radio Button Questions */}
                <Col xs={12} className="mt-30">
                    <Form.Group>
                        <Form.Label className="custom-label">Do you have a real estate agent? <span>*</span></Form.Label>
                        <div className="d-flex gap-3">
                            <Form.Check
                                type="radio"
                                name="hasRealtor"
                                label="Yes"
                                value="yes"
                                checked={formData.hasRealtor === 'yes'}
                                onChange={handleInputChange}
                                inline
                                className='custom-radio primary'
                            />
                            <Form.Check
                                type="radio"
                                name="hasRealtor"
                                label="No"
                                value="no"
                                checked={formData.hasRealtor === 'no'}
                                onChange={handleInputChange}
                                inline
                                className='custom-radio primary'
                            />
                        </div>
                    </Form.Group>
                </Col>

                <Col xs={12} className="mt-30">
                    <Form.Group>
                        <Form.Label className="custom-label">Are you buying this home on your own or with someone? <span>*</span></Form.Label>
                        <div className="d-flex gap-3">
                            <Form.Check
                                type="radio"
                                name="buyingWithOthers"
                                label="It's a family"
                                value="family"
                                checked={formData.buyingWithOthers === 'family'}
                                onChange={handleInputChange}
                                inline
                                className='custom-radio primary'
                            />
                            <Form.Check
                                type="radio"
                                name="buyingWithOthers"
                                label="I have a co-signer"
                                value="cosigner"
                                checked={formData.buyingWithOthers === 'cosigner'}
                                onChange={handleInputChange}
                                inline
                                className='custom-radio primary'
                            />
                        </div>
                    </Form.Group>
                </Col>


                <Col xs={12} className="mt-30">
                    <Form.Group>
                        <Form.Label className="custom-label">Have you had a bankruptcy within the past 7 years? <span>*</span></Form.Label>
                        <div className="d-flex gap-3">
                            <Form.Check
                                type="radio"
                                name="bankruptcy"
                                label="Yes"
                                value="yes"
                                checked={formData.bankruptcy === 'yes'}
                                onChange={handleInputChange}
                                inline
                                className='custom-radio primary'
                            />
                            <Form.Check
                                type="radio"
                                name="bankruptcy"
                                label="No"
                                value="no"
                                checked={formData.bankruptcy === 'no'}
                                onChange={handleInputChange}
                                inline
                                className='custom-radio primary'
                            />
                        </div>
                    </Form.Group>
                </Col>

                <Col xs={12} className="mt-30">
                    <Form.Group>
                        <Form.Label className="custom-label">Have you had a foreclosure or short sale in the past 4 years? <span>*</span></Form.Label>
                        <div className="d-flex gap-3">
                            <Form.Check
                                type="radio"
                                name="foreclosure"
                                label="Yes"
                                value="yes"
                                checked={formData.foreclosure === 'yes'}
                                onChange={handleInputChange}
                                inline
                                className='custom-radio primary'
                            />
                            <Form.Check
                                type="radio"
                                name="foreclosure"
                                label="No"
                                value="no"
                                checked={formData.foreclosure === 'no'}
                                onChange={handleInputChange}
                                inline
                                className='custom-radio primary'
                            />
                        </div>
                    </Form.Group>
                </Col>

            </Row>

            <div className="d-flex justify-content-center gap-3 mt-4 mt-lg-5">
                <Button className="custom-bttn clear-all w-150" onClick={handleBack}>
                    Back
                </Button>
                <Button className="custom-bttn style-3 w-150" onClick={currentStep == 2 ? handleSubmit : handleNext}>
                    Next
                </Button>

            </div>

        </div>

    );

    const renderStep3 = () => (
        <div className="step-content">

            {/* Choose Agent Section */}
            <div className="choose-agent-section">
                <h3 className="section-title">Choose one of the top Providers</h3>
                <p className="section-subtitle">Find real estate loan agent. Always review plan facts with your agent.</p>

                <div className="agents-list">
                    {providers.map((provider) => (
                        <Card
                            key={provider.id}
                            className={`agent-card ${selectedAgent === provider.id ? 'selected' : ''}`}
                            onClick={() => setSelectedAgent(provider.id)}
                        >
                            <Card.Body className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className='img-wrap'>
                                        <img src={provider.company_logo} alt={provider.name} className="agent-logo" />
                                    </div>
                                    <div className="text-wrap">
                                        <h6 className="mb-0">{provider.name}</h6>
                                        <div className="rating">
                                            <img src={Star} alt='' /> {provider.rating}
                                        </div>
                                    </div>
                                </div>
                                {/* <Button className="custom-bttn style-1 ani-1"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleSeeMore(provider.id);
                                    }}>
                                    See More <img src={ArrowIcon} alt='' />
                                </Button> */}

                                <a href={`${provider.website}`} target='blan' className="custom-bttn style-1 ani-1"
                                    >
                                    See More <img src={ArrowIcon} alt='' />
                                </a>
                            </Card.Body>
                        </Card>
                    ))}
                </div>
            </div>

            {/* <div className="d-flex justify-content-center gap-3 mt-4">
                <Button variant="outline-dark" className="px-5" onClick={handleBack}>
                Back
            </Button>
            </div> */}
        </div>
    );
    const navigate = useNavigate();
    const handleBackToHomepage = () => {
        navigate('/');
    };


    return (
        <>
            {!showThankYou && (
                <section className="get-pre-qualified-comp common-padding">
                    <Container>
                        <h2>Get a clearer picture of <br /><span>your finances</span></h2>
                        <div className="form-wrapper">
                            {renderStepIndicator()}
                            <Form onSubmit={handleSubmit} className={currentStep === 3 ? 'step-3-form' : ''}>
                                {currentStep === 1 && renderStep1()}
                                {currentStep === 2 && renderStep2()}
                                {currentStep === 3 && renderStep3()}
                                <p className="text-center text-danger mt-2">
                                    {error}
                                </p>
                            </Form>
                        </div>
                    </Container>
                </section>
            )}

            {showThankYou && (
                <section className="thankyou-box common-padding">
                    <Container>
                        <div className="thankyou-box-wrap">
                            <div className='text-wrap'>
                                <h3>Thanks for the info!<br /> That's all we need from you.</h3>
                                <p>We’ll use these details to find the most relevant properties for you.</p>
                            </div>
                            <Button className="custom-bttn w-300 style-3" onClick={handleBackToHomepage}>Back to homepage</Button>
                        </div>
                    </Container>
                </section>
            )}
        </>
    );
}

export default GetPreQualifiedComp;